import axios from "axios";

axios.interceptors.request.use(config => {
    config.headers['Authorization'] = localStorage.getItem("apiKey");
    return config;
});

axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response.status === 401) {
            alert('Wrong api key!');
            return Promise.reject(error);
        }
});

async function list() {
    return await axios.get('revelRestaurant/');
}

async function get(restaurantId) {
    return await axios.get('revelRestaurant/' + restaurantId);
}

async function update(restaurant) {
    return await axios.put('revelRestaurant/', restaurant);
}

async function create(restaurant) {
    return await axios.post('revelRestaurant/', restaurant);
}

async function generateImportCsv(comoBusinessId, pointsCalc) {
    try{
        return await axios.post(`import/${comoBusinessId}`, pointsCalc)
    } catch (error) {
        console.log(error.response);
        return {error};
    }
}

async function getImports(comoBusinessId) {
    return await axios.get(`import/${comoBusinessId}`);
}

async function download(resourceId) {
    return await axios.get(`import/${resourceId}`);
}

export default {
    list, get, update, create, generateImportCsv, getImports, download
}
